<template>
  <div>
    <div>
      <top-header :titleStyle="'padding:20px 5% 20px 10%'"></top-header>
    </div>
    <div class="content">
      <div class="content_box">
        <div class="group_61">
          <div v-if="isSelect == 1">
            <cenContents></cenContents>
          </div>
          <div v-if="isSelect == 2">
            <con></con>
          </div>
          <div v-if="isSelect == 3">
            <publicSentiment></publicSentiment>
          </div>
          <div v-if="isSelect == 4">
            <examine></examine>
          </div>
        </div>
      </div>
    </div>
    <div>
      <cenfooter></cenfooter>
    </div>
  </div>
</template>

<script>
import topHeader from "../components/home/headears.vue";
import cenContents from "../components/home/contents.vue";
import con from "../components/perio/perio";
import cenfooter from "../components/home/footers.vue";
import publicSentiment from "@/components/home/publicSentiment.vue";

import examine from "@/components/home/examine.vue";
// import topHeader from "../components/header"
// import botFooter from "../components/footer"
// import con from "../components/index/indexCon"
// import cnBase from "../components/index/chineseBase1"
// import cooperation from "../components/index/chineseCooperation"
export default {
  components: {
    // topHeader,botFooter,con,cnBase,cooperation
    topHeader,
    cenContents,
    con,
    cenfooter,
    publicSentiment,
    examine,
  },
  data() {
    return {
      isSelect: "1",
      isShow: sessionStorage.getItem("isLogin1") !== "1" ? true : false,
      userName: "admin",
      isShow1: null,
    };
  },
  created() {
    this.init();
  },
  async mounted() {
    let data = JSON.parse(sessionStorage.getItem("user"));
    if (data) {
      if (
        data.username == "科教处" ||
        data.username == "admin" ||
        data.username == "情报所" ||
        data.username == "刘飞蝶"
      ) {
        this.isShow1 = true;
      } else {
        this.isShow1 = false;
      }
    }
  },
  methods: {
    ishow(e) {
      this.isSelect = e;
    },
    btn(e) {
      this.isSelect = e;
    },
    init() {
      if (this.$route.query.coreType == "中华医学期刊") {
        this.isSelect = "2";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 90%;
  margin: 20px auto;
}
.active {
  background-color: rgba(11, 112, 193, 1) !important;
  color: #fff;
}
.isbgc {
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngec356d3f3fbbdde54cf623f477b30b5bc1e72c0dc89bb6002c03697db801bb67)
    100% no-repeat !important;
}
.isbgc2 {
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngdc155e89c19f763bb0825505c3245ed5aeaee5112639a1267dde5ea928a82709)
    100% no-repeat !important;
}
.isbgc3 {
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd46a1e99d36e0195ddf723bc75bf487aed38bbb28ea4d4d911e058f8a0b7ed6c)
    100% no-repeat !important;
}
.group_61 {
  width: 94%;
}
.group_60 {
  // margin-left: 200px;
  width: 6%;
  .box_2 {
    display: flex;
    justify-content: center;
    align-items: center;
    //   background-color: rgba(11, 112, 193, 1);
    background-color: rgba(11, 112, 193, 0.1);
    width: 100%;
    height: 104px;
    cursor: pointer;
    .box_3 {
      width: 22px;
      height: 20px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge1648031719bba5fb397e939db9b77a07352d239e003331ccfab33f673943526)
        100% no-repeat;
      background-size: 100% 100%;
      margin: auto;
    }
    .text_6 {
      margin-top: 14px;
      width: 32px;
      height: 22px;
      // color: rgba(255, 255, 255, 1);
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      text-align: center;

      line-height: 22px;
    }
  }
  .box_4 {
    text-align: center;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: rgba(11, 112, 193, 0.1);
    width: 100%;
    height: 104px;
    cursor: pointer;
    .image-text_7 {
      // width: 32px;
      height: 56px;

      .box_5 {
        width: 18px;
        height: 20px;
        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng92781dcbd4be4e9fcb6f77d077da843370109bd92b2ad83041b9574d290a8157)
          100% no-repeat;
        background-size: 100% 100%;
        margin: auto;
      }
      .text-group_1 {
        // color: rgba(0, 0, 0, 1);
        font-size: 16px;
        text-align: center;
        padding-top: 14px;
        line-height: 22px;
      }
    }
  }
  .box_6 {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(11, 112, 193, 0.1);
    width: 100%;
    height: 104px;
    cursor: pointer;
    .image-text_8 {
      width: 32px;
      height: 56px;

      .box_7 {
        width: 22px;
        height: 20px;
        background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng5c4d0f7ffc2e79895e2ee3d733765a7be8f747509ad86fb7bd303eb1104ebcfc)
          100% no-repeat;
        background-size: 100% 100%;
        margin: auto;
      }
      .text-group_2 {
        width: 32px;
        height: 22px;
        // color: rgba(0, 0, 0, 1);
        font-size: 16px;
        text-align: left;
        margin-top: 14px;

        line-height: 22px;
      }
    }
  }
}
</style>